import {
  IDatePickerStyleProps,
  IDatePickerStyles
} from '@fluentui/react/lib/DatePicker';
import { ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../teams-type';

export function getDatePickerStyles(themeName: string, _theme: ITheme) {
  return (props: IDatePickerStyleProps): Partial<IDatePickerStyles> => {
    const { theme } = props;
    const { palette } = theme;

    let HEADER_DIVIDER_BORDER_COLOR = palette.neutralQuaternary;
    let HOVER_BACKGROUND_COLOR = theme.palette.neutralLight;
    let HIGHLIGHTED_BACKGROUND_COLOR = palette.themeLight;
    let HIGHLIGHTED_TEXT_COLOR = palette.black;

    let HOVER_TEXT_COLOR = palette.black;

    let TODAY_TEXT_COLOR = palette.white;

    let FOCUS_TEXT_COLOR = palette.neutralTertiary;

    let DISABLED_BACKGROUND_COLOR = palette.white;
    let DISABLED_TEXT_COLOR = palette.neutralTertiary;

    if (themeName === 'dark') {
      HEADER_DIVIDER_BORDER_COLOR = palette.white;
      HOVER_BACKGROUND_COLOR = palette.white;
      TODAY_TEXT_COLOR = palette.white;

      DISABLED_BACKGROUND_COLOR = palette.neutralLight;
      DISABLED_TEXT_COLOR = palette.neutralTertiary;
    }

    if (themeName === 'contrast') {
      HOVER_BACKGROUND_COLOR = palette.themeDark;
      HIGHLIGHTED_BACKGROUND_COLOR = palette.themePrimary;
      HIGHLIGHTED_TEXT_COLOR = palette.white;

      HOVER_TEXT_COLOR = palette.white;

      TODAY_TEXT_COLOR = palette.white;

      FOCUS_TEXT_COLOR = palette.black;

      DISABLED_BACKGROUND_COLOR = palette.white;
      DISABLED_TEXT_COLOR = palette.black;
    }

    const styles: Partial<IDatePickerStyles> = {
      callout: {
        selectors: {
          '.ms-DatePicker table': {
            width: 'auto',
            marginRight: '0 !important' // !important needed to override ltr and rtl changes
          },
          'table th, .ms-DatePicker-day, .ms-DatePicker-day-button': {
            width: '32px',
            height: '32px',
            fontSize: FontSizes.size14
          },
          'table th': {
            color: palette.black,
            paddingTop: '2px',
            paddingBottom: '2px',
            textAlign: 'center'
          },
          'table td': {
            fontWeight: 'normal',
            color: palette.black
          },
          'table td:active, table td:hover, .ms-DatePicker-monthOption, .ms-DatePicker-monthOption:active, .ms-DatePicker-monthOption:hover': {
            background: HOVER_BACKGROUND_COLOR,
            fontWeight: 'normal',
            color: HOVER_TEXT_COLOR
          },
          'table td:hover, .ms-DatePicker-monthOption:hover': {
            background: HOVER_BACKGROUND_COLOR
          },
          'table td button': {
            cursor: 'pointer'
          },
          '.ms-DatePicker-header': {
            padding: '7px 6px 5px',
            height: 'auto',
            borderBottom: `1px solid ${HEADER_DIVIDER_BORDER_COLOR}`,
            boxSizing: 'border-box'
          },
          '.ms-DatePicker-monthPicker': {
            marginLeft: '0 !important', // !important needed to override ltr and rtl changes
            marginRight: '0 !important' // !important needed to override ltr and rtl changes
          },
          '.ms-DatePicker .ms-DatePicker-wrap': {
            paddingLeft: '0',
            paddingTop: '0',
            paddingBottom: '0',
            paddingRight: '0'
          },
          '.ms-DatePicker-currentYear': {
            paddingTop: 0,
            paddingBottom: 0
          },
          '.ms-DatePicker-monthAndYear': {
            fontWeight: 'bold',
            color: theme.palette.black
          },
          '.ms-FocusZone': {
            padding: '5px 7px 6px'
          },
          '.ms-DatePicker .ms-DatePicker-picker .ms-DatePicker-holder': {
            display: 'block',
            paddingTop: '0'
          },
          '.ms-DatePicker-monthComponents': {
            marginRight: '0 !important' // !important needed to override ltr and rtl changes
          },
          '.ms-DatePicker-day--infocus': {
            color: palette.neutralDark
          },
          '.ms-DatePicker-day--outfocus': {
            color: FOCUS_TEXT_COLOR
          },
          ".ms-DatePicker-day .ms-DatePicker-day--today, .ms-DatePicker-day .ms-DatePicker-day--today:active, .ms-DatePicker-day .ms-DatePicker-day--today:hover, .ms-DatePicker-monthOption[aria-selected='true'], .ms-DatePicker-monthOption[aria-selected='true']:active, .ms-DatePicker-monthOption[aria-selected='true']:hover": {
            borderRadius: '2px',
            background: palette.themePrimary,
            fontWeight: 'normal',
            color: TODAY_TEXT_COLOR
          },
          ".ms-DatePicker-day--highlighted, .ms-DatePicker-day--highlighted:hover, .ms-DatePicker-day--highlighted:active, .ms-DatePicker-monthOption[aria-selected='true'][tabindex='-1'], .ms-DatePicker-monthOption[aria-selected='true'][tabindex='-1']:active, .ms-DatePicker-monthOption[aria-selected='true'][tabindex='-1']:hover": {
            background: HIGHLIGHTED_BACKGROUND_COLOR,
            fontWeight: 'normal',
            color: HIGHLIGHTED_TEXT_COLOR
          },
          '.ms-DatePicker .js-goToday': {
            padding: '0',
            color: palette.themeSecondary,
            cursor: 'pointer',
            fontSize: FontSizes.size14
          },
          '.ms-DatePicker .js-goToday:hover': {
            color: palette.themePrimary
          },
          '.ms-DatePicker .js-goToday:disabled': {
            padding: '0',
            color: palette.neutralTertiary
          },
          '.ms-DatePicker .ms-DatePicker-monthOption': {
            fontSize: FontSizes.size14
          },
          '.ms-DatePicker-navContainer': {
            display: 'inherit'
          },
          '.ms-DatePicker-navContainer button': {
            background: 'transparent',
            color: theme.palette.black
          },
          '.ms-DatePicker-navContainer button:hover i': {
            fontWeight: 'bold'
          },
          '.ms-DatePicker-navContainer svg': {
            width: '28px',
            height: '28px',
            display: 'block'
          },
          '.ms-DatePicker-navContainer svg, .ms-DatePicker-navContainer svg .icons-default-fill': {
            fill: palette.neutralDark
          },
          '.ms-DatePicker-navContainer button:hover svg, .ms-DatePicker-navContainer button:hover svg .icons-default-fill': {
            fill: palette.themePrimary
          },
          '.ms-DatePicker-navContainer svg .icons-unfilled, .ms-DatePicker-navContainer button:hover .icons-filled': {
            display: 'block'
          },
          '.ms-DatePicker-navContainer svg .icons-filled, .ms-DatePicker-navContainer button:hover .icons-unfilled': {
            display: 'none'
          },
          '.ms-DatePicker button:focus:after': {
            zIndex: 1,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            outline: `1px solid ${palette.neutralDark}`,
            borderColor: palette.white
          },
          '[class*="divider_"]': {
            borderColor: `${HEADER_DIVIDER_BORDER_COLOR} !important`
          },
          '.ms-DatePicker-holder': {
            marginTop: 0
          },
          '[class*="showWeekNumbers_"': {
            paddingBottom: '30px !important'
          },
          '.ms-DatePicker-day--disabled': {
            background: DISABLED_BACKGROUND_COLOR,
            color: DISABLED_TEXT_COLOR
          }
        }
      }
    };

    return styles;
  };
}
